/**
 * Default "visited" colour presets shared between maps whose theme is
 * intrinsically tied to nature (national parks, tropical islands). Centralised
 * so the first-paint colour stays consistent across those maps and a tweak
 * only needs to happen in one place.
 *
 * Most maps inherit the brand-coral default from TravelMapShell — only maps
 * that explicitly need a different theme reach for one of these.
 */

// Forest green — reads as parks / reefs / outdoors on the first paint.
export const NATURE_DEFAULT_COLOR = { r: 34, g: 139, b: 34, a: 255 };
